import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {Helmet} from "react-helmet";
import { Box } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { parseIntoNumber } from '../utilities/helper';
import BidWidget from '../components/widgets/bid.widget';
import { APIResponse, Auction, TypeSnackbarPayload } from '../utilities/types';
import { getAuctionDetail } from '../apis';
import { RootState } from '../store';
import { showSnackbar } from '../store/slices/common.slice';

const AuctionDetailPage: React.FC = () => {
  const dispatch = useDispatch();
  const { isAuthenticated, user, token } = useSelector((state: RootState) => state.auth);

  const [searchParams] = useSearchParams();

  const [auction, setAuction] = useState<Auction>();

  // const { auction_id } = useParams<{ auction_id: string }>();
  const auction_id = searchParams.get('id');

  const fetchAuctionDetail = useCallback(async () => {
    try {
      const payload = { auction_id, user_id: isAuthenticated ? user?.id : null };
      const response = (await getAuctionDetail(payload)) as APIResponse<Auction>;
      if (response.status) {
        const auctionResponse = response.data as Auction;
        setAuction(auctionResponse);
      }
    } catch (err: any) {
      const snakbarpayload: TypeSnackbarPayload = { severity: 'error', message: err.message };
      if (err?.data?.message) {
        snakbarpayload.message = err?.data?.message;
      } else if (err?.statusText) {
        snakbarpayload.message = err?.statusText;
      }
      dispatch(showSnackbar(snakbarpayload));
    }
  }, [auction_id, dispatch, isAuthenticated, user]);

  useEffect(() => {
    fetchAuctionDetail();
  }, [fetchAuctionDetail])

  return (
    <>
      <Helmet>
        <title>{auction?.title} - Scrap E-Auction Online Scrap Metal Auction Platform</title>
        <meta name="description" content={auction?.description} />
      </Helmet>
      <Box sx={{ mx: 'auto' }}>
        <BidWidget auction_id={parseIntoNumber(auction_id)} />
      </Box>
    </>
  );
};

export default AuctionDetailPage;
